module.exports = __webpack_public_path__ + "img/listing-placeholder.c63389e.png";